module.exports = __webpack_public_path__ + "static/media/userManagementDash.f622165b.png";